import React, { useState, useCallback } from 'react';
import { Table, TableContainer } from '../../styles/lib/table';
import {
  FaExclamationTriangle,
  FaRegCheckCircle,
  FaRegHourglass,
  FaRegMoneyBillAlt,
  FaUndo,
  FaRegFile,
  FaInfoCircle,
} from 'react-icons/fa';
import { Pagination } from '../pagination';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
interface DynamicTableProps {
  columns: string[];
  data: any[];
  isLoading?: boolean;
  paginationSize: number;
  totalItems: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  onPageSizeChange?: (size: number) => void;
}

export const DynamicTable: React.FC<DynamicTableProps> = ({
  columns,
  data,
  isLoading = false,
  paginationSize,
  totalItems,
  currentPage,
  onPageChange,
  onPageSizeChange,
}) => {
  const renderCellContent = (col: string, value: any) => {
    if (col === 'Status' && value.icon) {
      const colorMap: Record<string, string> = {
        check: '#1BC167',
        times: '#FFB100',
        money: '#2480E9',
        returned: '#007BFF',
        incident: '#E63946',
        received: '#007BFF',
        document: '#FF69B4',
      };

      const iconMap: Record<string, React.JSX.Element> = {
        check: <FaRegCheckCircle size={14} color={colorMap.check} />,
        times: <FaRegHourglass size={14} color={colorMap.times} />,
        money: <FaRegMoneyBillAlt size={14} color={colorMap.money} />,
        returned: <FaUndo size={14} color={colorMap.returned} />,
        incident: <FaExclamationTriangle size={14} color={colorMap.incident} />,
        document: <FaRegFile size={14} color={colorMap.document} />,
      };

      return (
        <span
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            color: colorMap[value.icon],
          }}
        >
          {iconMap[value.icon]}
          {value.text}
        </span>
      );
    }
    return value as string;
  };

  if (isLoading) {
    return <p>Carregando dados...</p>;
  }

  return (
    <div>
      <TableContainer>
        <Table>
          <thead className="dynamic">
            <tr>
              {columns.map((col, index) => {
                if (col === 'Data da Parcela') {
                  return (
                    <th key={index}>
                      {col}{' '}
                      <FaInfoCircle
                        size={13}
                        data-tooltip-id="info-tooltip"
                        data-tooltip-content="São exibidas somente parcelas com vencimento a partir de 29/07/2025"
                        style={{ marginLeft: '4px', cursor: 'help' }}
                      />
                      <Tooltip id="info-tooltip" place="top" />
                    </th>
                  );
                }
                return <th key={index}>{col}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {totalItems > 0 ? (
              data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((col, colIndex) => {
                    const cellContent = row[col];
                    const displayContent =
                      typeof cellContent === 'string' &&
                      cellContent.length > 20 ? (
                        <span title={cellContent}>{`${cellContent.substring(
                          0,
                          17,
                        )}...`}</span>
                      ) : (
                        cellContent
                      );
                    return (
                      <td key={colIndex}>
                        {renderCellContent(col, displayContent)}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length}>Nenhum dado disponível</td>
              </tr>
            )}
          </tbody>
        </Table>
      </TableContainer>
      <Pagination
        currentPage={currentPage}
        paginationSize={paginationSize}
        onPageChange={onPageChange}
        totalItems={totalItems}
      />
    </div>
  );
};
